import { Divider } from '@mui/material'
import { styled } from '@mui/material/styles'

export default styled(Divider)(({ theme }) => ({
  color: theme.palette.customGrey[500],
  fontFamily: '"Outfit", Arial, sans-serif',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '20px',
  margin: '24px 0px 32px 0px'
}))
